export const FIRST_LOGIN_CHANGE_PASSWORD = 'FIRST_LOGIN_CHANGE_PASSWORD'
